<div class="dashboard ynex-style">
  <section class="welcome-block">
    <div class="welcome-row">
      <div class="welcome-text">
        <h1 class="welcome-title">Bonjour, {{ userName }}</h1>
        <p class="welcome-subtitle">Poste de pilotage Peek&Go — actions prioritaires et indicateurs.</p>
      </div>
      <form class="period-form" (submit)="$event.preventDefault(); load()">
        <label class="period-field">
          <span class="period-label">Du</span>
          <input type="date" class="period-input" [(ngModel)]="fromDate" name="fromDate" />
        </label>
        <label class="period-field">
          <span class="period-label">Au</span>
          <input type="date" class="period-input" [(ngModel)]="toDate" name="toDate" />
        </label>
        <button type="submit" class="period-btn" [disabled]="isLoading">Actualiser</button>
      </form>
    </div>
  </section>

  <!-- À appeler (02/11/2026) : les prochains appels, clients d'abord, sans aller dans Prospection. -->
  <section class="dash-calls card-section">
    <div class="section-head">
      <h2 class="section-title">
        <i name="phone" [size]="18" Icons></i>
        À appeler
      </h2>
    </div>
    <app-upcoming-callbacks [limit]="5" />
  </section>

  <section id="actions" class="dash-actions card-section">
    <div class="section-head">
      <h2 class="section-title">
        <i name="infos-bubble" [size]="20" Icons></i>
        À traiter en priorité
      </h2>
      @if (actionItems.length) {
        <span class="dash-pill">{{ actionItems.length }} alerte(s)</span>
      }
    </div>
    @if (isLoading) {
      <p class="dash-muted">Chargement…</p>
    } @else {
      <app-admin-action-list [items]="actionItems" />
    }
  </section>

  <section class="stats-row">
    @if (isLoading) {
      <p class="stats-loading">Chargement des indicateurs…</p>
    }
    @for (stat of stats; track stat.label) {
      <a
        [routerLink]="stat.link"
        [queryParams]="stat.queryParams ?? null"
        class="stat-card"
        [class.stat-card--warn]="stat.tone === 'warn'"
        [class.stat-card--critical]="stat.tone === 'critical'">
        <div class="stat-content">
          <span class="stat-label">{{ stat.label }}</span>
          <span class="stat-value">{{ stat.value }}</span>
          <span class="stat-sub">{{ stat.sub }}</span>
        </div>
        <span class="stat-link">Voir →</span>
      </a>
    }
  </section>

  <div class="dashboard-grid">
    <section class="card-section quick-actions">
      <h2 class="section-title">Accès rapide</h2>
      <div class="quick-links">
        <a routerLink="/admin/paiements/finance" class="quick-link">Finance plateforme</a>
        <a routerLink="/admin/paiements/transactions" class="quick-link">Transactions</a>
        <a routerLink="/admin/paiements/sante" class="quick-link">Santé paiements</a>
        <a routerLink="/admin/organisations" class="quick-link">Organisations</a>
        <a routerLink="/admin/onboarding/inscriptions" class="quick-link">Inscriptions</a>
        <a routerLink="/admin/parametres/equipe" class="quick-link">Équipe admin</a>
      </div>
    </section>
  </div>
</div>
